import React, { useEffect } from "react";
import { HashRouter } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import { setUser, setSession } from "./Redux/Slices/authslice";
import { useDispatch, useSelector } from "react-redux";
import Navigation from "./Navigation.js";
import "remixicon/fonts/remixicon.css";
import { messaging } from "./Firebase/config.js";
import { onMessage } from "firebase/messaging";
import Widgets from "./Widgets/index.js";

const LoadingIndicator = () => {
  const isLoading = useSelector((state) => state.loading.isLoading);
  return isLoading ? <Widgets.CircularLoader /> : null;
};

function App() {
  const isAuthenticated = useSelector((state) => state.user.isAuthenticated);
  const dispatch = useDispatch();

  useEffect(() => {
    const checkAuthentication = async () => {
      const userFromLocalStorage = JSON.parse(localStorage.getItem("user"));
      const sessionFromLocalStorage = JSON.parse(localStorage.getItem("session"));

      if (userFromLocalStorage && sessionFromLocalStorage) {
        dispatch(setUser(userFromLocalStorage));
        dispatch(setSession(sessionFromLocalStorage));
      }
    };

    checkAuthentication();
  }, [dispatch]);
  useEffect(() => {
    if ("Notification" in window) {
      Notification.requestPermission()
        .then((permission) => {
          if (permission === "granted") {
            console.log("Notification permission granted.");
          } else {
            console.warn("Notification permission denied.");
          }
        })
        .catch((error) => {
          console.error("Error requesting notification permission:", error);
        });

      onMessage(messaging, (payload) => {
        console.log("Received foreground message:", payload);

        const notificationTitle = payload.notification?.title || "Default Title";
        const notificationOptions = {
          body: payload.notification?.body || "Default Body",
        };

        if (Notification.permission === "granted") {
          new Notification(notificationTitle, notificationOptions);
        } else {
          console.warn("Notifications are not permitted.");
        }
      });
    } else {
      console.warn("Notifications are not supported in this browser.");
    }
  }, []);
  useEffect(() => {
    const clearExpiredSession = () => {
      const storedSession = localStorage.getItem("session");
      if (storedSession) {
        const sessionData = JSON.parse(storedSession);
        if (sessionData.expiresAt && new Date().getTime() > sessionData.expiresAt) {
          localStorage.removeItem("session");
          localStorage.removeItem("user");
        }
      }
    };
    clearExpiredSession();
  }, []);

  return (
    <div>
      <Toaster toastOptions={{ duration: 4000, position: "bottom-center" }} containerStyle={{ zIndex: 99999 }} />
      <div className="loading-app-container">
        <LoadingIndicator />
      </div>
      <HashRouter basename="/">
        <Navigation />
      </HashRouter>
    </div>
  );

  function LoginRedirect() {
    // return isAuthenticated ? <Navigate to="/home" /> : <LoginPage />;
  }
}

export default App;
